<div class="LesitungEdit row" *ngIf="Entry && Entry != null">
  <div class="row">
    <div class="row">
      <div class="col edit">
        <AdminCard [Item]="Entry">
          <div class="row">
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" id="name" [(ngModel)]="Entry.name">
                <label for="name">Bezeichnung</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="input-group mb-3">
                <div class="form-floating">
                  <input type="number" class="form-control" step="0.01" min="0.01" id="Preis" placeholder="0.00" [(ngModel)]="Entry.kosten">
                  <label for="Preis">Preis</label>
                </div>
                <span class="input-group-text" id="basic-addon2">€</span>
              </div>
            </div>
          </div>
        </AdminCard>
      </div>
    </div>
  </div>
</div>
<div class="row Button">
  <div class="col"></div>
  <div class="col-auto">
    <div class="btn btn-success" (click)="SaveData()">Speichern</div>
  </div>
</div>
<ng-template #successTpl> Speichern erfolgreich! </ng-template>
